<section class="editor-panel">

  <!-- Header info banner
  <ng-container *ngIf="sectionType == 'header'">
    <div class="info-banner">
      <mat-icon>info</mat-icon>
      <span>Changes made here will update all pages using the header</span>
    </div>
  </ng-container> -->

  <!-- Display toggles — TOP -->
  <div
    *ngIf="hasDisplayKeys(content.display) || (content.hasOwnProperty('image') && content?.image?.hasOwnProperty('showImage')) || action?.hasOwnProperty('display') || content.hasOwnProperty('tag') || content?.inputText?.length > 0 || content?.hasOwnProperty('showSearchBar') || content?.socialLinks?.hasOwnProperty('display')"
    class="editor-section">
    <p class="section-heading">Display</p>
    <div class="toggle-list">
      <div class="section-row toggle-row" *ngIf="sectionType === 'header' && style?.hasOwnProperty('headline')">
        <span class="row-label">Headline</span>
        <input class="toggle-input" type="checkbox" [(ngModel)]="style.headline.display" role="switch"
          [class.active]="style?.headline?.display">
      </div>
      <div class="section-row toggle-row" *ngIf="sectionType === 'header' && style?.hasOwnProperty('countdown')">
        <span class="row-label">Countdown Banner</span>
        <input class="toggle-input" type="checkbox" [(ngModel)]="style.countdown.display" role="switch"
          [class.active]="style?.countdown?.display">
      </div>
      <div class="section-row toggle-row" *ngIf="content.hasOwnProperty('tag')">
        <span class="row-label">Tag</span>
        <input class="toggle-input" type="checkbox" [(ngModel)]="content.tag.display" role="switch"
          [class.active]="content.tag.display">
      </div>
      <ng-container *ngIf="content?.inputText?.length > 0">
        <div class="section-row toggle-row" *ngFor="let item of content?.inputText">
          <span class="row-label">{{ item?.label }}</span>
          <input class="toggle-input" type="checkbox" [(ngModel)]="item.isRTE" role="switch"
            [class.active]="item?.isRTE" (ngModelChange)="onTextValueChange()">
        </div>
      </ng-container>
      <div class="section-row toggle-row" *ngIf="content?.display?.hasOwnProperty('showHeading') && !content.listItem">
        <span class="row-label">Heading</span>
        <input class="toggle-input" type="checkbox" [(ngModel)]="content.display.showHeading" role="switch"
          [class.active]="content.display.showHeading">
      </div>
      <div class="section-row toggle-row" *ngIf="content?.display?.hasOwnProperty('showContent') && !content.listItem">
        <span class="row-label">Description</span>
        <input class="toggle-input" type="checkbox" [(ngModel)]="content.display.showContent" role="switch"
          [class.active]="content.display.showContent">
      </div>
      <div class="section-row toggle-row" *ngIf="content?.display?.hasOwnProperty('showText')">
        <span class="row-label">Text</span>
        <input class="toggle-input" type="checkbox" [(ngModel)]="content.display.showText"
          (ngModelChange)="imageUpdated()" role="switch" [class.active]="content?.display?.showText">
      </div>
      <div class="section-row toggle-row" *ngIf="action?.hasOwnProperty('display')">
        <span class="row-label">Button</span>
        <input class="toggle-input" type="checkbox" [(ngModel)]="$any(action).display" role="switch"
          [class.active]="$any(action).display">
      </div>
      <div class="section-row toggle-row"
        *ngIf="content.hasOwnProperty('image') && content?.image?.hasOwnProperty('showImage')">
        <span class="row-label">Image</span>
        <input class="toggle-input" type="checkbox" [(ngModel)]="content.image.showImage" role="switch"
          [class.active]="content.image.showImage">
      </div>
      <div class="section-row toggle-row" *ngIf="content?.display?.hasOwnProperty('showImage') && !content.listItem">
        <span class="row-label">Image</span>
        <input class="toggle-input" type="checkbox" [(ngModel)]="content.display.showImage"
          (ngModelChange)="imageUpdated()" role="switch" [class.active]="content.display.showImage">
      </div>
      <div class="section-row toggle-row" *ngIf="content?.display?.hasOwnProperty('showIcon') && !content.listItem">
        <span class="row-label">Icon</span>
        <input class="toggle-input" type="checkbox" [(ngModel)]="content.display.showIcon"
          (ngModelChange)="iconUpdated()" role="switch" [class.active]="content?.display?.showIcon">
      </div>
      <div class="section-row toggle-row" *ngIf="content?.display?.hasOwnProperty('showButton')">
        <span class="row-label">Button</span>
        <input class="toggle-input" type="checkbox" [(ngModel)]="content.display.showButton" role="switch"
          [class.active]="content.display.showButton">
      </div>
      <div class="section-row toggle-row" *ngIf="content?.display?.hasOwnProperty('showIncludeditems')">
        <span class="row-label">Included Item</span>
        <input class="toggle-input" type="checkbox" [(ngModel)]="content.display.showIncludeditems" role="switch"
          [class.active]="content.display.showIncludeditems">
      </div>
      <div class="section-row toggle-row" *ngIf="content?.display?.hasOwnProperty('showLink') && !content.listItem">
        <span class="row-label">Link</span>
        <input class="toggle-input" type="checkbox" [(ngModel)]="content.display.showLink" role="switch"
          [class.active]="content.display.showLink">
      </div>
      <div class="section-row toggle-row" *ngIf="content?.hasOwnProperty('showSearchBar') && businessType === 'E_COMMERCE'">
        <span class="row-label">Search Bar</span>
        <input class="toggle-input" type="checkbox" [(ngModel)]="content.showSearchBar" role="switch"
          [class.active]="content?.showSearchBar">
      </div>
      <div class="section-row toggle-row" *ngIf="content?.socialLinks?.hasOwnProperty('display')">
        <span class="row-label">Social Links</span>
        <input class="toggle-input" type="checkbox" [(ngModel)]="content.socialLinks.display" role="switch"
          [class.active]="content?.socialLinks?.display">
      </div>
    </div>
    <!-- Link type — only for non-list sections -->
    <div class="mt-12" *ngIf="content.display?.showLink && !content.listItem">
      <div class="section-row">
        <span class="row-label">
          Link type
          <mat-icon #tooltip="matTooltip" class="info-icon"
            matTooltip="Select Button to display a clickable button linked to a URL. Select List to show a list of items, each potentially linked to a URL"
            matTooltipPosition="right" matTooltipClass="infotooltip" (click)="tooltip.toggle()">info</mat-icon>
        </span>
        <div class="seg-buttons">
          <div class="seg-left" (click)="content.display.linkType = 'Button'"
            [ngClass]="{'seg-selected': content.display.linkType === 'Button'}">Button</div>
          <div class="seg-right" (click)="content.display.linkType = 'List Item'"
            [ngClass]="{'seg-selected': content.display.linkType === 'List Item'}">List Item</div>
        </div>
      </div>
    </div>
    <!-- Tag label — shown when tag toggle is on -->
    <div class="mt-10" *ngIf="content?.tag?.display">
      <p class="row-label mb-6">Tag label</p>
      <input type="text" class="field-input w-100" [(ngModel)]="content.tag.label"
        (ngModelChange)="onTextValueChange()">
    </div>
  </div>

  <!-- ── Text section: accordion (editors always in DOM to fix quill init) -->
  <ng-container *ngIf="hasAnyTextEnabled()">
    <div class="editor-section">
      <p class="section-heading">Text</p>
      <div class="text-nav-list">
        <ng-container *ngFor="let item of content?.inputText">
          <div class="text-item-accordion" *ngIf="item?.isRTE">
            <div class="text-nav-row" (click)="toggleTextItem(item)">
              <div class="text-nav-info">
                <span class="text-nav-label">{{ item?.label }}</span>
                <span class="text-nav-preview" *ngIf="item?.value && currentEditTextItem !== item">
                  {{ getPlainText(item?.value) }}
                </span>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="15"
                height="15" class="chevron-icon" [class.chevron-open]="currentEditTextItem === item">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m9 18 6-6-6-6" />
              </svg>
            </div>

            <div class="text-item-editor" [hidden]="currentEditTextItem !== item">
              <app-simpo-text-editor [(value)]="item.value" [editable]="true"
                (valueChange)="onTextValueChange()"></app-simpo-text-editor>
            </div>

          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>

  <!-- Contact form -->
  <div *ngIf="content?.hasOwnProperty('contactField')" class="editor-section">
    <app-contact-form-editor [contactField]="content?.contactField"></app-contact-form-editor>
  </div>

  <!-- Address -->
  <div *ngIf="content?.hasOwnProperty('address')" class="editor-section">
    <p class="section-heading">Address</p>
    <span class="row-desc">Business address</span>
    <mat-form-field appearance="outline" style="width: 100%;" class="mt-8">
      <input type="text" placeholder="Search location" matInput [formControl]="searchBox" [matAutocomplete]="auto2"
        [(ngModel)]="searchLocation" (keyup)="search()" />
      <mat-autocomplete #auto2="matAutocomplete">
        <mat-option *ngFor="let option of searchResults | async; index as i" [value]="option?.place_name"
          (click)="selectedLocations(option)">{{ option?.place_name | titlecase }}</mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <!-- Video link -->
  <div *ngIf="content?.hasOwnProperty('videoLink')" class="editor-section">
    <p class="section-heading">Video link</p>
    <p class="row-label mt-8">Link Address</p>
    <input type="text" class="field-input w-100 mt-6" [(ngModel)]="content.videoLink.url"
      (ngModelChange)="onTextValueChange()">
  </div>

  <!-- End Date (Countdown Banner) -->
  <div *ngIf="content?.hasOwnProperty('endDate')" class="editor-section">
    <p class="section-heading">End Date</p>
    <p class="row-label mt-8">Countdown target date</p>
    <input type="date" class="field-input w-100 mt-6" [(ngModel)]="content.endDate"
      (ngModelChange)="onTextValueChange()">
  </div>

  <!-- Site name and logo -->
  <div *ngIf="content?.hasOwnProperty('siteNameAndLogo')"
    class="editor-section d-flex align-items-center justify-content-between">
    <p class="section-heading">Site name and logo</p>
    <div class="seg-buttons">
      <div *ngFor="let option of ['custom', 'same as header']; let i = index"
        (click)="content.siteNameAndLogo = option; changeSiteNameAndLogo()" [ngClass]="{
         'seg-selected': content?.siteNameAndLogo === option,
         'seg-left': i === 0,
         'seg-right': i === 1
       }">{{ option | titlecase }}</div>
    </div>
  </div>

  <!-- Site Name (hidden for header; footer custom mode still shows it) -->
  <div class="editor-section"
    *ngIf="sectionType !== 'header' && content?.siteName && (!content?.hasOwnProperty('siteNameAndLogo') || content?.siteNameAndLogo === 'custom')">
    <p class="section-heading">Site name</p>
    <input type="text" class="field-input w-100" [(ngModel)]="content.siteName.value" maxlength="60"
      (ngModelChange)="onTextValueChange()">
  </div>

  <!-- Links Title -->
  <div *ngIf="content?.hasOwnProperty('linksTitle')" class="editor-section">
    <p class="section-heading">Links Title</p>
    <input class="field-input w-100" [(ngModel)]="content.linksTitle.value"
      placeholder="You can add your footer links title" (ngModelChange)="onTextValueChange()" />
  </div>

  <!-- Get in touch / Footer Center Info -->
  <div *ngIf="content?.hasOwnProperty('getInTouch')" class="editor-section">
    <div class="section-row">
      <span class="section-heading mb-0">Footer Center Info</span>
      <div class="form-check form-switch" *ngIf="content?.getInTouch?.hasOwnProperty('display')">
        <input class="toggle-input" type="checkbox" [(ngModel)]="content.getInTouch.display" role="switch"
          [class.active]="content?.getInTouch?.display">
      </div>
    </div>
    <div *ngIf="content?.getInTouch?.display">
      <div *ngFor="let inputText of content?.getInTouch?.inputText" class="mt-10">
        <p class="row-label mb-6">{{inputText?.label}}</p>
        <input type="text" class="field-input w-100" *ngIf="!inputText?.isRTE" [(ngModel)]="inputText.value"
          (ngModelChange)="onTextValueChange()">
        <app-simpo-text-editor *ngIf="inputText?.isRTE" [(value)]="inputText.value" [editable]="true"
          (valueChange)="onTextValueChange()"></app-simpo-text-editor>
      </div>
    </div>
  </div>

  <!-- Logo -->
  <div
    *ngIf="content?.hasOwnProperty('logo') && (!content?.hasOwnProperty('siteNameAndLogo') || content?.siteNameAndLogo === 'custom')"
    class="editor-section">
    <div class="section-row">
      <span class="section-heading mb-0">Logo</span>
      <span class="action-link" (click)="openLogoStyleEditor()">Edit</span>
    </div>
    <div class="color-preview mt-8" [ngStyle]="{'background-color': color}">
      {{content?.siteName?.value}}
    </div>
    <div class="mt-2 fs-13">
      * For best results, use a transparent logo with a width between 200-400px. Logo will be resized to fit within header height.
    </div>
  </div>

  <!-- Popular searches -->
  <ng-container *ngIf="content?.hasOwnProperty('popularSearches')">
    <div class="editor-section">
      <div class="section-row">
        <span class="row-label">Show Popular Searches</span>
        <input class="toggle-input" type="checkbox" [(ngModel)]="content.popularSearches" role="switch"
          [class.active]="content?.popularSearches">
      </div>
    </div>
  </ng-container>

  <!-- Text description -->
  <ng-container *ngIf="content?.hasOwnProperty('textDescription')">
    <div class="editor-section">
      <div class="section-row">
        <span class="row-label">Show Additional info</span>
        <input class="toggle-input" type="checkbox" [(ngModel)]="content.textDescription.display" role="switch"
          [class.active]="content?.textDescription?.display">
      </div>
    </div>
  </ng-container>

  <!-- Show Products -->
  <div *ngIf="content?.display?.hasOwnProperty('showProducts') && !content?.display?.showImage" class="editor-section">
    <div class="section-row">
      <span class="row-label">Show Products</span>
      <input [(ngModel)]="content.display.showProducts" class="toggle-input" role="switch" type="checkbox"
        [class.active]="content?.display?.showProducts">
    </div>
  </div>

  <!-- Collection -->
  <div *ngIf="content?.hasOwnProperty('collectionId')" class="editor-section">
    <p class="section-heading">Collection</p>
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-select [(ngModel)]="content.collectionId" placeholder="Select a collection">
        <ng-container *ngFor="let collection of collectionList">
          <mat-option [value]="collection?.collectionId" (click)="changeCollection(collection?.collectionName)">
            {{collection?.collectionName}}
          </mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Menu List -->
  <div *ngIf="content?.hasOwnProperty('menuId') && businessType === 'E_COMMERCE'" class="editor-section">
    <p class="section-heading">Menu</p>
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-select placeholder="--Select Menu--" [(ngModel)]="content.menuId" (ngModelChange)="changeMenuList()">
        <ng-container *ngFor="let menu of menuList; let idx = index">
          <mat-option [value]="menu?.id">{{ menu?.name | titlecase }}</mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Collection Ids -->
  <div *ngIf="content?.hasOwnProperty('collectionIds')" class="editor-section">
    <p class="section-heading">Collection List</p>
    <div class="custom-dropdown">
      <div class="dropdown-header" (click)="isDropdownOpen = !isDropdownOpen">
        <span class="placeholder-text">
          Search and select collection...
        </span>
        <mat-icon class="dropdown-arrow" [class.open]="isDropdownOpen">keyboard_arrow_up</mat-icon>
      </div>
      <div class="dropdown-body" [class.open]="isDropdownOpen">
        <div class="search-container">
          <input type="text" placeholder="Search by collection name..." />
        </div>
        <div class="d-flex flex-column" *ngIf="collectionList.length > 0">
          <div class="selectalls-check d-flex align-items-center justify-content-between">
            <mat-checkbox (click)="onSelectAllCollection(allCollectionCheckbox)"
              #allCollectionCheckbox></mat-checkbox>select
            all
          </div>
          <ng-container *ngFor="let collection of collectionList; let idx = index">
            <div class="d-flex align-items-center options">
              <mat-checkbox></mat-checkbox>
              <mat-option [value]="collection?.collectionId">{{ collection?.collectionName | titlecase }}</mat-option>
            </div>
          </ng-container>
        </div>
        <div class="empty-text" *ngIf="collectionList?.length === 0">
          No Collections found
        </div>
      </div>
    </div>
    <div *ngIf="content?.collectionIds?.length" cdkDropList (cdkDropListDropped)="dropCollection($event)"
      class="drag-list mt-8">
      <div *ngFor="let collectionId of content?.collectionIds" cdkDrag>
        <div class="drag-item">
          <mat-icon class="drag-handle">drag_indicator</mat-icon>
          <span class="item-title">{{getCollectionName(collectionId) | titlecase}}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Categories Ids -->
  <div *ngIf="content?.hasOwnProperty('categoriesIds')" class="editor-section">
    <p class="section-heading">Categories List</p>
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-select multiple placeholder="--Select Categories--" [(ngModel)]="content.categoriesIds"
        #categorySelectElement>
        <div class="selectalls-check">
          <mat-checkbox (click)="onSelectAllCategory(allCategoryCheckbox)" #allCategoryCheckbox>select
            all</mat-checkbox>
        </div>
        <ng-container *ngFor="let category of categoryList; let idx = index">
          <mat-option [value]="category?.categoryId" (click)="onCategorySelect(category?.categoryId)">
            {{ category?.categoryName | titlecase }}
          </mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
    <div *ngIf="content?.categoriesIds?.length" cdkDropList (cdkDropListDropped)="dropCategory($event)"
      class="drag-list mt-8">
      <div *ngFor="let categoryId of content?.categoriesIds" cdkDrag>
        <div class="drag-item">
          <mat-icon class="drag-handle">drag_indicator</mat-icon>
          <span class="item-title">{{getCategoryName(categoryId) | titlecase}}</span>
        </div>
      </div>
    </div>
  </div>


  <!-- List Items -->
  <div cdkDropList class="editor-section" style="overflow-x: hidden;" (cdkDropListDropped)="drop($event)"
    *ngIf="content.listItem">
    <p class="section-heading">{{content.listItem.label ?? 'List Items'}}</p>

    <!-- Per-item display toggles -->
    <div class="list-display-toggles" *ngIf="content.display && hasDisplayKeys(content.display)">
      <p class="toggle-group-label">Display</p>
      <div class="toggle-list">
        <div class="section-row toggle-row" *ngIf="content.display.hasOwnProperty('showImage')">
          <span class="row-label">Image</span>
          <input class="toggle-input" type="checkbox" [(ngModel)]="content.display.showImage"
            (ngModelChange)="imageUpdated()" role="switch" [class.active]="content.display.showImage">
        </div>
        <div class="section-row toggle-row" *ngIf="content.display.hasOwnProperty('showIcon')">
          <span class="row-label">Icon</span>
          <input class="toggle-input" type="checkbox" [(ngModel)]="content.display.showIcon"
            (ngModelChange)="iconUpdated()" role="switch" [class.active]="content?.display?.showIcon">
        </div>
        <div class="section-row toggle-row" *ngIf="content.display.hasOwnProperty('showHeading')">
          <span class="row-label">Heading</span>
          <input class="toggle-input" type="checkbox" [(ngModel)]="content.display.showHeading" role="switch"
            [class.active]="content.display.showHeading">
        </div>
        <div class="section-row toggle-row" *ngIf="content.display.hasOwnProperty('showContent')">
          <span class="row-label">Description</span>
          <input class="toggle-input" type="checkbox" [(ngModel)]="content.display.showContent" role="switch"
            [class.active]="content.display.showContent">
        </div>
        <div class="section-row toggle-row" *ngIf="content.display.hasOwnProperty('showLink')">
          <span class="row-label">Link</span>
          <input class="toggle-input" type="checkbox" [(ngModel)]="content.display.showLink" role="switch"
            [class.active]="content.display.showLink">
        </div>
      </div>
    </div>

    <div class="items-list">
      <div *ngFor="let item of content?.listItem?.data; let i = index" cdkDrag class="list-item-row">
        <mat-icon class="drag-handle">drag_indicator</mat-icon>

        <img [ngClass]="{'logo-thumb': sectionType === 'logoShowcase'}" [src]="item?.image?.url || item?.image?.attachment"
          [alt]="item?.image?.altText || item?.image?.altName" *ngIf="!content?.display?.showIcon && item?.image && (item?.image?.url || item?.image?.attachment)"
          class="item-thumb">
        <img [ngClass]="{'logo-thumb': sectionType === 'logoShowcase'}" [src]="item?.icon?.url"
          *ngIf="content?.display?.showIcon && item?.icon && item?.icon?.url" class="item-thumb">
        <div class="no-thumb" *ngIf="(item?.image && !item?.image?.url && !item?.image?.attachment) || (item?.icon && !item?.icon?.url)"></div>

        <div *ngIf="item?.video" class="item-video flex-1">
          <input type="text" [(ngModel)]="item.video.url" class="field-input w-100 mb-6" placeholder="Video URL"
            (ngModelChange)="onTextValueChange()">
          <input type="text" [(ngModel)]="item.video.description" class="field-input w-100" placeholder="Description"
            (ngModelChange)="onTextValueChange()">
        </div>

        <div *ngIf="item?.inputText?.length > 0" class="item-info flex-1">
          <p class="item-title">{{ getPlainText(item?.inputText[0]?.value) }}</p>
          <p class="item-subtitle" [innerHtml]="getSanitizedData(item?.inputText[1]?.value)"
            *ngIf="item?.inputText?.length > 1"></p>
        </div>

        <div class="item-actions">
          <span class="act-edit" (click)="openListItem(item, i)" *ngIf="!item?.video">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="16"
              height="16">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
                d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
            </svg>
          </span>
          <span *ngIf="item?.video && content?.display?.showProducts" class="act-add" matTooltip="Add Products"
            matTooltipPosition="above" (click)="openAddProdcutsEditor(content?.listItem, item)">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="16"
              height="16">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.5v15m7.5-7.5h-15" />
            </svg>
          </span>
          <span class="act-delete" (click)="deleteData('LIST_ITEM', i)">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="16"
              height="16">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
                d="m19 7-.867 12.142A2 2 0 0 1 16.138 21H7.862a2 2 0 0 1-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v3M4 7h16" />
            </svg>
          </span>
        </div>
      </div>
    </div>
    <button class="add-item-btn mt-8" (click)="addNewListItem()">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="13"
        height="13" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 5v14M5 12h14" />
      </svg>
      Add item
    </button>
  </div>

  <!-- Countdown Banner content (header only, visible when countdown is enabled) -->
  <div *ngIf="sectionType === 'header' && style?.countdown?.display && content?.countdownBanner?.content"
    class="editor-section">
    <p class="section-heading">Countdown Banner</p>
    <ng-container *ngFor="let item of content.countdownBanner.content.inputText">
      <p class="row-label mt-8">{{ item?.label }}</p>
      <input type="text" class="field-input w-100 mt-6" *ngIf="!item?.isRTE" [(ngModel)]="item.value"
        (ngModelChange)="onTextValueChange()">
      <app-simpo-text-editor *ngIf="item?.isRTE" [(value)]="item.value" [editable]="true"
        (valueChange)="onTextValueChange()"></app-simpo-text-editor>
    </ng-container>
    <p class="row-label mt-8">End Date</p>
    <input type="datetime-local" class="field-input w-100 mt-6" [(ngModel)]="content.countdownBanner.content.endDate"
    (ngModelChange)="onTextValueChange()">
  </div>


  <!-- Navbar Buttons -->
  <!-- <div class="editor-section" *ngIf="content?.hasOwnProperty('navbarButtons')">
    <p class="section-heading">Show Link</p>
    <div class="toggle-list">
      <div class="section-row toggle-row" *ngFor="let link of content?.navbarButtons">
        <span class="row-label">{{link?.label}}</span>
        <input class="toggle-input" type="checkbox" [(ngModel)]="link.showHeader" role="switch"
          [class.active]="link?.showHeader">
      </div>
    </div>
  </div> -->

  <!-- No of posts -->
  <ng-container *ngIf="content?.hasOwnProperty('noOfPosts')">
    <div class="editor-section">
      <div class="section-row">
        <span class="section-heading mb-0">No of posts</span>
        <div class="seg-buttons">
          <div class="seg-left" (click)="content.noOfPosts = 3" [ngClass]="{'seg-selected': content?.noOfPosts === 3}">3
          </div>
          <div class="seg-mid" (click)="content.noOfPosts = 6" [ngClass]="{'seg-selected': content?.noOfPosts === 6}">6
          </div>
          <div class="seg-right" (click)="content.noOfPosts = 9" [ngClass]="{'seg-selected': content?.noOfPosts === 9}">
            9
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Button Content -->
  <div
    *ngIf="action && (action?.buttons?.length == 0 || action?.buttons?.[0]?.content) && (!action.hasOwnProperty('display') || $any(action).display)"
    class="editor-section">
    <div class="section-row">
      <span class="section-heading mb-0">{{sectionType === 'image' ? 'Action' : 'Button'}}</span>
    </div>

    <div *ngIf="!action.hasOwnProperty('display') || $any(action).display" class="mt-10">
      <div
        *ngIf="(sectionType === 'text_image' ||  sectionType === 'blogPost' || sectionType === 'logoShowcase' || sectionType === 'image'); else showElse">
        <app-button-editor [buttonData]="action.buttons[0].content" [templatePage]="templatePage"
          [currentPageIndex]="currentPageIndex"></app-button-editor>
      </div>
      <ng-template #showElse>
        <div class="items-list">
          <div *ngFor="let button of action?.buttons; let i = index" class="list-item-row">
            <mat-icon style="color: #9CA3AF; font-size: 18px; width: 20px; height: 20px;">link</mat-icon>
            <span class="item-title flex-1">{{button?.content?.label}}</span>
            <div class="item-actions">
              <span class="act-edit" (click)="editButton(button)">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="16"
                  height="16">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
                    d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                </svg>
              </span>
              <span class="act-delete" (click)="deleteData('BUTTON', i)"
                *ngIf="sectionType != 'newsLetter' && sectionType != 'productList'">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="16"
                  height="16">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
                    d="m19 7-.867 12.142A2 2 0 0 1 16.138 21H7.862a2 2 0 0 1-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v3M4 7h16" />
                </svg>
              </span>
            </div>
          </div>
        </div>
        <ng-container *ngIf="sectionType !== 'contact us'">
          <button class="add-item-btn mt-8" (click)="addNewButton()"
            *ngIf="action.buttons.length < 2 || sectionType === 'buttongridsection'">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="13"
              height="13" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 5v14M5 12h14" />
            </svg>
            Add Button
          </button>
        </ng-container>
      </ng-template>
    </div>
  </div>

  <!-- Social Links -->
  <div *ngIf="content?.hasOwnProperty('socialLinks') && sectionType !== 'header'" class="editor-section">
    <div class="section-row">
      <span class="section-heading mb-0">Social Links</span>
    </div>
    <div *ngIf="!content?.socialLinks?.hasOwnProperty('display') || content?.socialLinks?.display" class="mt-10">
      <div class="items-list">
        <div *ngFor="let channel of content?.socialLinks?.channels; let i = index" class="list-item-row">
          <div class="social-icon">
            <svg *ngIf="channel?.type === ChannelType.FACEBOOK" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
              viewBox="0 0 24 24" width="18" height="18">
              <path fill-rule="evenodd"
                d="M10.4375 21.8784C5.65941 21.1274 2 16.9877 2 12 2 6.48086 6.48086 2 12 2c5.5191 0 10 4.48086 10 10 0 4.9877-3.6594 9.1274-8.4375 9.8784v-6.9878h2.3301L16.3359 12h-2.7734v-1.8758c0-.79084.3874-1.5617 1.6296-1.5617h1.261V6.10156s-1.1443-.19531-2.2385-.19531c-2.2842 0-3.7771 1.38438-3.7771 3.89063V12H7.89844v2.8906h2.53906v6.9878Z"
                clip-rule="evenodd"></path>
            </svg>
            <svg *ngIf="channel?.type === ChannelType.TWITTER" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
              viewBox="0 0 24 24" width="18" height="18">
              <path
                d="M13.6756 10.6218 20.2324 3h-1.5537l-5.6933 6.61788L8.43817 3H3.1935l6.8763 10.0074L3.1935 21h1.55384l6.01226-6.9887L15.5618 21h5.2447l-7.1313-10.3782h.0004Zm-2.1282 2.4738-.6967-.9965-5.54349-7.92939h2.38662l4.47367 6.39919.6967.9966 5.8152 8.318h-2.3866l-4.7454-6.7875v-.0004Z">
              </path>
            </svg>
            <svg *ngIf="channel?.type === ChannelType.LINKEDIN" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
              viewBox="0 0 24 24" width="18" height="18">
              <path fill-rule="evenodd"
                d="M19.5565 2C20.9051 2 22 3.09492 22 4.44352V19.5565C22 20.9051 20.9051 22 19.5565 22H4.44352C3.09492 22 2 20.9051 2 19.5565V4.44352C2 3.09492 3.09488 2 4.44352 2H19.5565ZM8.26801 18.5343V9.71723H5.33676v8.81707h2.93125Zm10.56789 0v-5.0562c0-2.7083-1.446-3.96822-3.3742-3.96822-1.5549 0-2.2513.85512-2.6413 1.45572V9.71723H9.88988c.03887.82737 0 8.81707 0 8.81707h2.93052v-4.9241c0-.2636.0189-.527.0966-.7154.2115-.5264.694-1.0716 1.5037-1.0716 1.0599 0 1.4846.8088 1.4846 1.9936v4.7175h2.9306ZM6.82219 5.4657c-1.00289 0-1.65813.65934-1.65813 1.52352 0 .84601.63532 1.52351 1.61934 1.52351 1.02207 0 1.67719-.6775 1.67719-1.52351-.01895-.86297-.63442-1.52164-1.6384-1.52352Z"
                clip-rule="evenodd"></path>
            </svg>
            <svg *ngIf="channel?.type === ChannelType.YOUTUBE" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
              viewBox="0 0 24 24" width="18" height="18">
              <path fill-rule="evenodd"
                d="M21.0053 5.6191c.5996.6477.7946 2.11879.7946 2.11879S22 9.46405 22 11.1908v1.618c0 1.7268-.2001 3.453-.2001 3.453s-.1956 1.4705-.7946 2.1169c-.6859.7654-1.4461.8449-1.8754.8897-.0469.0049-.0899.0094-.1283.0143-2.799.2145-7.0016.222-7.0016.222s-5.20038-.0507-6.80025-.2145c-.07572-.0151-.16746-.0268-.27131-.0402-.50666-.0651-1.3018-.1673-1.93375-.8719-.59957-.6465-.79463-2.1169-.79463-2.1169S2 14.5356 2 12.8082v-1.618c0-1.72615.20006-3.45231.20006-3.45231s.19569-1.47109.79463-2.11879c.68895-.76815 1.4516-.84541 1.88002-.88881.04511-.00457.08651-.00876.12373-.01335C7.79681 4.5 11.995 4.5 11.995 4.5h.0094s4.1982 0 6.9972.21694c.0372.00459.0786.00879.1238.01336.4285.0434 1.1916.12069 1.8799.8888Zm-5.251 6.3832-6.25196 3.7512V8.25117l6.25196 3.75113Z"
                clip-rule="evenodd"></path>
            </svg>
            <svg *ngIf="channel?.type === ChannelType.INSTAGRAM" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
              viewBox="0 0 24 24" width="18" height="18">
              <path fill-rule="evenodd"
                d="M12 2c5.5191 0 10 4.48086 10 10 0 5.5191-4.4809 10-10 10-5.51914 0-10-4.4809-10-10C2 6.48086 6.48086 2 12 2Zm0 3.75c-1.6974 0-1.9102.00719-2.57688.03762-.66523.03035-1.11957.13601-1.51714.29051-.41098.15972-.75953.37343-1.107.72089-.34746.34746-.56117.69602-.72089 1.107-.1545.39753-.26012.85187-.29051 1.5171C5.75719 10.0898 5.75 10.3026 5.75 12s.00719 1.9102.03758 2.5769c.03039.6652.13601 1.1195.29051 1.5171.15972.411.37343.7595.72089 1.107.34747.3475.69602.5612 1.107.7209.39757.1545.85191.2601 1.51714.2905.66668.0304.87948.0376 2.57688.0376s1.9102-.0072 2.5769-.0376c.6652-.0304 1.1195-.136 1.5171-.2905.411-.1597.7595-.3734 1.107-.7209.3475-.3475.5612-.696.7209-1.107.1545-.3976.2601-.8519.2905-1.5171.0304-.6667.0376-.8795.0376-2.5769 0-1.6974-.0072-1.9102-.0376-2.57688-.0304-.66523-.136-1.11957-.2905-1.5171-.1597-.41098-.3734-.75954-.7209-1.107s-.696-.56117-1.107-.72089c-.3976-.1545-.8519-.26016-1.5171-.29051C13.9102 5.75719 13.6974 5.75 12 5.75Zm0 1.12613c1.6688 0 1.8665.00637 2.5255.03645.6094.02781.9403.12961 1.1606.21519.2917.11336.4999.24883.7186.46754.2187.21867.3542.42692.4675.71864.0856.22023.1874.55113.2152 1.1605.0301.65905.0365.85675.0365 2.52555s-.0064 1.8665-.0365 2.5255c-.0278.6094-.1296.9403-.2152 1.1606-.1133.2917-.2488.4999-.4675.7186-.2187.2187-.4269.3542-.7186.4675-.2203.0856-.5512.1874-1.1606.2152-.6589.0301-.8566.0365-2.5255.0365s-1.8666-.0064-2.52555-.0365c-.60937-.0278-.94027-.1296-1.1605-.2152-.29176-.1133-.49997-.2488-.71868-.4675-.21871-.2187-.35414-.4269-.4675-.7186-.08558-.2203-.18742-.5512-.21523-1.1606-.03008-.659-.03641-.8567-.03641-2.5255s.00633-1.8665.03641-2.52555c.02781-.60937.12965-.94027.21523-1.1605.11336-.29172.24879-.49997.4675-.71864.21871-.21871.42692-.35418.71868-.46754.22023-.08558.55113-.18738 1.1605-.21519.65905-.03008.85675-.03645 2.52555-.03645Zm0 1.91442c-1.7725 0-3.20945 1.43695-3.20945 3.20945S10.2275 15.2095 12 15.2095s3.2095-1.437 3.2095-3.2095c0-1.7725-1.437-3.20945-3.2095-3.20945Zm0 5.29275c-1.1506 0-2.08332-.9327-2.08332-2.0833 0-1.1506.93272-2.08332 2.08332-2.08332S14.0833 10.8494 14.0833 12 13.1506 14.0833 12 14.0833Zm4.0863-5.41955c0 .41422-.3358.74996-.7501.74996-.4141 0-.7499-.33574-.7499-.74996s.3358-.75.7499-.75c.4143 0 .7501.33578.7501.75Z"
                clip-rule="evenodd"></path>
            </svg>
            <svg *ngIf="channel?.type === ChannelType.TELEGRAM" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
              viewBox="0 0 24 24" width="18" height="18">
              <path fill-rule="evenodd"
                d="M22 12c0 5.5229-4.4771 10-10 10-5.52285 0-10-4.4771-10-10C2 6.47715 6.47715 2 12 2c5.5229 0 10 4.47715 10 10Zm-9.6417-2.61755c-.9726.40455-2.91653 1.24185-5.83173 2.51195-.47339.1883-.72136.3725-.74394.5525-.03815.3044.34296.4242.86192.5874.0706.0222.14374.0452.21872.0695.51059.166 1.19741.3602 1.55446.3679.32388.007.68537-.1265 1.08446-.4006 2.72381-1.8386 4.12981-2.7679 4.21801-2.788.0623-.0141.1486-.0319.2071.0201.0585.052.0527.1504.0465.1768-.0377.1609-1.5335 1.5516-2.3077 2.2714-.2415.2244-.4127.3836-.4477.42-.0784.0814-.1583.1584-.2351.2325-.4743.4572-.83.8001.0197 1.3601.4084.2691.7352.4917 1.0612.7137.356.2424.7111.4842 1.1705.7854.117.0767.2288.1564.3377.234.4143.2954.7865.5608 1.2464.5184.2672-.0245.5432-.2758.6834-1.0252.3313-1.771.9825-5.6083 1.133-7.18949.0132-.13853-.0034-.31583-.0167-.39367-.0134-.07782-.0412-.18872-.1424-.2708-.1198-.09722-.3048-.11772-.3875-.11627-.3761.00663-.9531.20728-3.7303 1.36238Z"
                clip-rule="evenodd"></path>
            </svg>
            <svg *ngIf="channel?.type === ChannelType.THREADS" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
              viewBox="0 0 24 24" width="18" height="18">
              <path
                d="M12.1482 21.6888h-.0058c-2.89118-.0194-5.1138-.9727-6.60781-2.833-1.32737-1.6568-2.01334-3.9608-2.03659-6.848v-.0136c.02325-2.88921.70922-5.19128 2.03853-6.84806C7.0286 3.28395 9.25316 2.33057 12.1424 2.31119h.0116c2.2168.0155 4.0712.5852 5.511 1.6936 1.3545 1.04252 2.3079 2.52685 2.833 4.41423l-1.6471.45925c-.8914-3.19731-3.1469-4.83085-6.7047-4.85604-2.34853.01744-4.12546.75573-5.28037 2.19355C5.7865 7.56253 5.22842 9.50804 5.20711 12c.02131 2.492.57939 4.4375 1.66066 5.7842 1.15491 1.4398 2.93184 2.1781 5.28043 2.1936 2.118-.0155 3.519-.5097 4.6836-1.651 1.3293-1.3022 1.306-2.9008.8797-3.8736-.25-.5736-.7054-1.0503-1.3196-1.4126-.155 1.0909-.5019 1.9746-1.0367 2.6412-.7151.8894-1.7285 1.3758-3.0113 1.4455-.9708.0523-1.9068-.1763-2.63149-.6472-.85843-.5561-1.36031-1.4049-1.41457-2.3931-.05232-.9612.32942-1.8448 1.07352-2.4881.71114-.6143 1.71104-.9747 2.89304-1.0425.8701-.0485 1.6859-.0097 2.4377.1143-.1007-.5988-.3022-1.07546-.6045-1.41844-.4147-.47282-1.0561-.7131-1.9049-.71891h-.0232c-.6821 0-1.6084.18796-2.19743 1.06577l-1.41844-.95145c.7906-1.17428 2.07337-1.82149 3.61587-1.82149h.0349c2.5791.0155 4.1158 1.59478 4.2689 4.35032.0872.0368.1744.0755.2596.1143 1.2034.5658 2.0831 1.4223 2.5462 2.4784.6434 1.4707.7035 3.8678-1.2498 5.7803-1.494 1.4611-3.3058 2.1219-5.8753 2.1393h-.0058Zm.81-9.4388c-.1958 0-.3934.0058-.5969.0174-1.4824.0833-2.40667.7635-2.3544 1.7304.0543 1.0135 1.1724 1.4844 2.2479 1.4262.9882-.0523 2.2749-.4379 2.4919-2.9957-.5464-.1183-1.1452-.1783-1.7885-.1783Z">
              </path>
            </svg>
          </div>
          <p class="item-title flex-1 mb-0 truncate">{{channel?.link}}</p>
          <ng-container *ngIf="channel?.link?.length > 0">
            <span class="act-edit" (click)="editChannel(channel)">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="16"
                height="16">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
                  d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
              </svg>
            </span>
            <span class="act-delete" (click)="deleteData('SOCIAL_LINK', i)">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="16"
                height="16">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
                  d="m19 7-.867 12.142A2 2 0 0 1 16.138 21H7.862a2 2 0 0 1-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v3M4 7h16" />
              </svg>
            </span>
          </ng-container>
        </div>
      </div>
      <button class="add-item-btn mt-8" (click)="addNewChannel()">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="13"
          height="13" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 5v14M5 12h14" />
        </svg>
        Add Channel
      </button>
    </div>
  </div>

  <!-- Table -->
  <div class="editor-section"
    *ngIf="content?.hasOwnProperty('numberOfColumns') && content?.hasOwnProperty('numberOfRows')">
    <p class="section-heading">Table</p>
    <div class="section-row mb-8">
      <span class="row-label">Columns</span>
      <div class="counter">
        <button class="counter-btn" (click)="content.numberOfColumns = content.numberOfColumns - 1; updateColumns()"
          [disabled]="content.numberOfColumns <= 1"><mat-icon>remove</mat-icon></button>
        <span class="counter-value">{{ content.numberOfColumns }}</span>
        <button class="counter-btn" (click)="content.numberOfColumns = content.numberOfColumns + 1; updateColumns()">
          <mat-icon>add</mat-icon></button>
      </div>
    </div>
    <div class="section-row">
      <span class="row-label">Rows</span>
      <div class="counter">
        <button class="counter-btn" (click)="content.numberOfRows = content.numberOfRows - 1; updateRows()"
          [disabled]="content.numberOfRows <= 1"><mat-icon>remove</mat-icon></button>
        <span class="counter-value">{{ content.numberOfRows }}</span>
        <button class="counter-btn" (click)="content.numberOfRows = content.numberOfRows + 1; updateRows()">
          <mat-icon>add</mat-icon></button>
      </div>
    </div>
  </div>

  <!-- Display Branding -->
  <div class="editor-section" *ngIf="content?.hasOwnProperty('displayBranding')">
    <div class="section-row">
      <span class="section-heading mb-0">Made with simpo</span>
      <input class="toggle-input" type="checkbox" [(ngModel)]="content.displayBranding" role="switch"
        [class.active]="content?.displayBranding">
    </div>
  </div>


</section>